import React from 'react';
import { Box } from '@mui/material';

interface LogoProps {
  size?: number;
  color?: string;
  variant?: 'default' | 'white';
}

const Logo: React.FC<LogoProps> = ({ size = 40, variant = 'default' }) => {
  return (
    <Box
      component="img"
      src="/sersal-logo.png"
      alt="Sersal Logo"
      sx={{
        width: size,
        height: 'auto',
        display: 'block',
        objectFit: 'contain',
        // Le logo a un fond clair/blanc, donc on le garde tel quel même pour la variante white
        // Si besoin de contraste sur fond sombre, on peut ajouter un fond blanc
        ...(variant === 'white' && {
          bgcolor: 'white',
          borderRadius: 1,
          padding: 0.5,
        }),
      }}
    />
  );
};

export default Logo;
